import { actionTypes } from '../constants';

const createInitialState = () => ({
  selectedRecordId: null,
  selectedDocType: null,
  search: '',
});

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.attachmentsFilterSelectedRecordChanged: {
      const selectedRecordId =
        state.selectedRecordId === payload ? null : payload;

      return { ...state, selectedRecordId, selectedDocType: null, search: '' };
    }

    case actionTypes.attachmentsFilterSelectedDocTypeChanged: {
      return { ...state, selectedDocType: payload };
    }

    case actionTypes.attachmentsFilterSearchChanged: {
      return { ...state, search: payload };
    }

    case actionTypes.attachmentsFilterReset: {
      return createInitialState();
    }

    default:
      return state;
  }
};
